import { useEffect, useRef } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import {
  HomeIcon,
  PlacesIcon,
  ForMeIcon,
  MapIcon,
  FlightsIcon,
  LighthouseIcon,
  MoreIcon,
} from '@/components/Icons';
import { InstallPrompt } from '@/components/InstallPrompt';
import { TABS } from '@/lib/tabs';

const ICONS = {
  '/': HomeIcon,
  '/places': PlacesIcon,
  '/favorites': ForMeIcon,
  '/resort': LighthouseIcon,
  '/map': MapIcon,
  '/flights': FlightsIcon,
  '/more': MoreIcon,
} as const;

export function Layout() {
  const mainRef = useRef<HTMLElement>(null);
  const { pathname } = useLocation();

  useEffect(() => {
    mainRef.current?.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return (
    <div className="app-shell">
      <main className="app-main" ref={mainRef}>
        <Outlet />
      </main>
      <InstallPrompt />
      <nav className="bottom-nav" aria-label="Primary">
        {TABS.map(({ to, label, chromeLabel, end }) => {
          const Icon = ICONS[to];
          return (
            <NavLink key={to} to={to} end={end} aria-label={label}>
              <span className="bottom-nav__icon-wrap">
                <Icon />
              </span>
              <span>{chromeLabel}</span>
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
}
